import { SYSTEM } from '../constants/MessageType';
import { SECTIONS } from './DisplayTypes';
let incrementingId = 0;
export const createSystemMessage = (message, source, threadId, showTimeStamp) => ({
  actions: [],
  displayType: SECTIONS,
  query: {
    intent: 'unknown'
  },
  id: incrementingId++,
  sections: [{
    id: 'text',
    text: message,
    type: 'PLAIN_TEXT'
  }],
  response: '',
  value: '',
  source,
  time: Date.now(),
  thread_id: threadId,
  type: SYSTEM,
  showTimeStamp
});